module.exports = __webpack_public_path__ + "img/undraw_dev_focus_b9xo.c07a23fe.svg";